import React from "react";
import { ClassNameProps, If, makeClassName, Row, StyleProps, toGrammaticalNumber } from "@hex-insights/core";
import { Icon } from "../../../../Components/Icon";
import { MediaAttachment } from "../../../../Utilities";
import { MediaAttachmentUtilities } from "../../../Utilities";
import styles from "./styles.module.css";

type MediaAttachmentsSummaryProps = {
	mediaAttachments: Pick<MediaAttachment, "isFile" | "fileContentType">[] | null | undefined;
	withLabels?: boolean;
} & Partial<ClassNameProps & StyleProps>;

export function MediaAttachmentsSummary({
	mediaAttachments,
	withLabels = false,
	className,
	style,
}: MediaAttachmentsSummaryProps) {
	const { numImageAttachments, numVideoAttachments, numFileAttachments, numLinkAttachments } = React.useMemo(
		() => MediaAttachmentUtilities.countSplitMediaAttachments(mediaAttachments),
		[mediaAttachments],
	);

	return (
		<Row
			justify="spaced-start"
			horizontalSpacing="0.5rem"
			align="center"
			className={makeClassName(styles["summary"], "nowrap", className)}
			style={style}
		>
			<If condition={numImageAttachments > 0}>
				<Row justify="spaced-start" horizontalSpacing="0.25rem" align="center">
					<Icon.Image /> {withLabels ? toGrammaticalNumber("Image", numImageAttachments, true) : numImageAttachments}
				</Row>
			</If>
			<If condition={numVideoAttachments > 0}>
				<Row justify="spaced-start" horizontalSpacing="0.25rem" align="center">
					<Icon.Video /> {withLabels ? toGrammaticalNumber("Video", numVideoAttachments, true) : numVideoAttachments}
				</Row>
			</If>
			<If condition={numFileAttachments > 0}>
				<Row justify="spaced-start" horizontalSpacing="0.25rem" align="center">
					<Icon.File /> {withLabels ? toGrammaticalNumber("File", numFileAttachments, true) : numFileAttachments}
				</Row>
			</If>
			<If condition={numLinkAttachments > 0}>
				<Row justify="spaced-start" horizontalSpacing="0.25rem" align="center">
					<Icon.Link /> {withLabels ? toGrammaticalNumber("Link", numLinkAttachments, true) : numLinkAttachments}
				</Row>
			</If>
		</Row>
	);
}
